import { useEnvironment } from '@/react/portainer/environments/queries/useEnvironment';
import { useIsSwarm } from '@/react/docker/proxy/queries/useInfo';
import {
  isKubernetesEnvironment,
  isDockerEnvironment,
} from '@/react/portainer/environments/utils';
import { EnvironmentId } from '@/react/portainer/environments/types';

export function useEnvironmentType(environmentId?: EnvironmentId) {
  const environmentQuery = useEnvironment(environmentId);
  const environment = environmentQuery.data;

  const isSwarm = useIsSwarm(environmentId, {
    enabled:
      !!environmentId && !!environment && isDockerEnvironment(environment.Type),
  });

  if (!environment || !environmentId) {
    return '';
  }

  if (isKubernetesEnvironment(environment.Type)) {
    return 'kubernetes';
  }

  if (isDockerEnvironment(environment.Type)) {
    if (isSwarm) {
      return 'swarm';
    }
    return 'docker';
  }

  return '';
}
